import React from 'react';
import {hashHistory, Link} from 'react-router';
import {Paper, CircularProgress, FlatButton} from 'material-ui';
import {observable} from 'mobx';
import {inject, observer} from 'mobx-react';

@inject('markerStore')
@observer
export default class MiniRainfallWatch extends React.Component {

  @observable intervalIndex = 0;

  getSortedArray = (items) => {
    let sortedArray = [];
    let dangerItems = items.filter(item => item.status === 'DANGER').sort((a, b) => +a.stationIndex < +b.stationIndex ? -1 : 1);
    let warningItems = items.filter(item => item.status === 'WARNING').sort((a, b) => +a.stationIndex < +b.stationIndex ? -1 : 1);
    let bwlItems = items.filter(item => item.status === 'BELOW WARNING LEVEL').sort((a, b) => +a.stationIndex < +b.stationIndex ? -1 : 1);
    // let ndItems = items.filter(item => item.status === null);

    if (dangerItems.length) sortedArray = [...sortedArray, ...dangerItems.filter(b => b.stationIndex), ...dangerItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    if (warningItems.length) sortedArray = [...sortedArray, ...warningItems.filter(b => b.stationIndex), ...warningItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    if (bwlItems.length) sortedArray = [...sortedArray, ...bwlItems.filter(b => b.stationIndex), ...bwlItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    // if(ndItems.length) sortedArray = [ ...sortedArray, ...ndItems.sort((a,b) => a.stationIndex && a.name < b.name ?-1:1)];

    return sortedArray;
  };

  onClickHeader = () => hashHistory.push('/rainfall_watch');

  getIntervalHour = () => {
    if(this.intervalIndex === 0){
      return '1 hr'
    }else if(this.intervalIndex === 1){
      return '3 hr'
    }else if(this.intervalIndex === 2){
      return '6 hr'
    }else if(this.intervalIndex === 3){
      return '12 hr'
    }else if(this.intervalIndex === 4){
      return '24 hr'
    }
  };

  changeInterval = (interval) => {
    this.intervalIndex = interval;
  };

  render() {
    let {markerStore} = this.props;
    let getColor = status => {
      switch (status) {
        case 'BELOW WARNING LEVEL':
          return 'green';
        // case 'WARNING':
        //   return 'coral';
        // case 'DANGER':
        //   return 'red';
        default:
          return 'black';
      }
    };

    let style = {
      minWidth:'35px',
      width:'20%',
      height:'25px',
      lineHeight:'25px'
    };
    let labelStyle={
      padding:'0',
      fontWeight:'normal',
      fontSize:'10px'
    };

    return (
      <Paper zDepth={1} style={{width: this.props.mobView?'49%':'100%', height: '280px'}}>
        <h5 className="myTableHead">
          <span>Rainfall Watch</span>
          <span className="pull-right" style={{fontWeight: '100', fontSize: 'small', padding: '0px'}} onClick={this.onClickHeader}>see all</span>
        </h5>
        <div className="inline-it" style={{background:'#e9ebee'}}>
          <FlatButton secondary={this.intervalIndex === 0} label={'1 HR'} style={style} labelStyle={labelStyle} onClick={() => this.changeInterval(0)}/>
          <FlatButton secondary={this.intervalIndex === 1} label={'3 HR'} style={style} labelStyle={labelStyle} onClick={() => this.changeInterval(1)}/>
          <FlatButton secondary={this.intervalIndex === 2} label={'6 HR'} style={style} labelStyle={labelStyle} onClick={() => this.changeInterval(2)}/>
          <FlatButton secondary={this.intervalIndex === 3} label={'12 HR'} style={style} labelStyle={labelStyle} onClick={() => this.changeInterval(3)}/>
          <FlatButton secondary={this.intervalIndex === 4} label={'24 HR'} style={style} labelStyle={labelStyle} onClick={() => this.changeInterval(4)}/>
        </div>
        <ul style={{maxHeight: '220px', overflowY: 'scroll', margin: '0px'}}>{
          markerStore.rainfall_raw.length ? this.getSortedArray(markerStore.rainfall_raw).map((item, index) => (
            <li style={{marginLeft: 0}}>
              <Link to={`/basin/${item.id}`} className={item.status ? `${item.status.split(' ')[0]} mini-watch-item` :'mini-watch-item'}>
                <div>{item.name}</div>
                <div style={{color: getColor(item.status), padding: '0px'}}>{item.averages && item.averages[this.intervalIndex] && item.averages[this.intervalIndex].value !== null && item.averages[this.intervalIndex].value !== 'N/A' ? item.averages[this.intervalIndex].value+ ' mm' : '-'}</div>
                {/*<div style={{padding: '0px'}}>{item.averages && item.averages[this.intervalIndex] && item.averages[this.intervalIndex].value !== null && item.averages[this.intervalIndex].value !== 'N/A' ? item.averages[this.intervalIndex].value+ ' mm' : '-'}</div>*/}
              </Link>
            </li>
          )) :
            <div className="spinner"><CircularProgress/></div>
        }</ul>
      </Paper>
    );

    // return (
    //   <Paper zDepth={1} style={{width: '100%', height: '280px'}}>
    //     <h5 className="myTableHead">
    //       Rainfall Watch
    //       <span className="pull-right" style={{fontWeight: '100', fontSize: 'small'}} onClick={this.onClickHeader}>see all</span>
    //     </h5>
    //     <div style={{
    //       maxHeight: '462px',
    //       width: '424px',
    //       overflowY: 'scroll',
    //       margin: '0px',
    //       transform: 'scale(0.5) translate(-203px, -219px)'
    //     }}><RainfallWatch/></div>
    //   </Paper>
    // );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/MiniRainfallWatch.js